<template>
    <div>
        <div style="margin-bottom: 5px;">
            <el-input v-model="keyword" placeholder="请输入标题/内容" suffix-icon="el-icon-search" style="width: 220px;"
                      @keyup.enter.native="loadPost"></el-input>
            <el-button type="primary" style="margin-left: 5px;" @click="loadPost">查询</el-button>
            <el-button type="success" @click="resetParam">重置</el-button>
            <el-button type="primary" style="margin-left: 5px;" @click="add">新增介绍</el-button>
            <span style="margin-left: 10px; color: #999; font-size: 12px;">同步展示在前台首页「三大风格介绍」板块</span>
        </div>
        <el-table :data="tableData"
                  :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                  border>
            <el-table-column prop="id" label="ID" width="60"></el-table-column>
            <el-table-column prop="sort" label="排序" width="70"></el-table-column>
            <el-table-column prop="title" label="标题" width="220"></el-table-column>
            <el-table-column prop="content" label="内容" min-width="300" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
            <el-table-column prop="operate" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button size="small" type="success" @click="mod(scope.row)">编辑</el-button>
                    <el-popconfirm title="确定删除吗？" @confirm="del(scope.row)" style="margin-left: 5px;">
                        <el-button slot="reference" size="small" type="danger">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[5, 10, 20, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>

        <el-dialog :title="form.id ? '编辑介绍' : '新增介绍'" :visible.sync="centerDialogVisible" width="45%" center>
            <el-form ref="form" :rules="rules" :model="form" label-width="80px">
                <el-form-item label="标题" prop="title">
                    <el-col :span="22"><el-input v-model="form.title" placeholder="如：🍰 洛丽塔 Lolita"></el-input></el-col>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <el-col :span="22"><el-input v-model="form.content" type="textarea" :rows="5"></el-input></el-col>
                </el-form-item>
                <el-form-item label="排序">
                    <el-col :span="22"><el-input v-model="form.sort" placeholder="数字越小越靠前（默认0）"></el-input></el-col>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "IntroManage",
        data() {
            return {
                tableData: [],
                pageSize: 10,
                pageNum: 1,
                total: 0,
                keyword: '',
                centerDialogVisible: false,
                form: {
                    id: '',
                    title: '',
                    content: '',
                    sort: '0'
                },
                rules: {
                    title: [{required: true, message: '请输入标题', trigger: 'blur'}],
                    content: [{required: true, message: '请输入内容', trigger: 'blur'}]
                }
            }
        },
        methods: {
            resetForm() {
                this.$refs.form && this.$refs.form.resetFields();
            },
            del(row) {
                this.$axios.get(this.$httpUrl + '/intro/del?id=' + row.id).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '操作成功！', type: 'success'});
                        this.loadPost()
                    } else {
                        this.$message({message: res.msg || '操作失败！', type: 'error'});
                    }
                })
            },
            mod(row) {
                this.centerDialogVisible = true
                this.$nextTick(() => {
                    this.form.id = row.id
                    this.form.title = row.title
                    this.form.content = row.content
                    this.form.sort = row.sort == null ? '0' : row.sort + ''
                })
            },
            add() {
                this.centerDialogVisible = true
                this.$nextTick(() => {
                    this.resetForm()
                    this.form = {id: '', title: '', content: '', sort: '0'}
                })
            },
            save() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let body = Object.assign({}, this.form)
                        if (body.sort === '' || body.sort == null) {
                            body.sort = 0
                        }
                        let url = this.form.id ? '/intro/update' : '/intro/save'
                        this.$axios.post(this.$httpUrl + url, body).then(res => res.data).then(res => {
                            if (res.code == 200) {
                                this.$message({message: '操作成功！', type: 'success'});
                                this.centerDialogVisible = false
                                this.loadPost()
                                this.resetForm()
                            } else {
                                this.$message({message: res.msg || '操作失败！', type: 'error'});
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageNum = 1
                this.pageSize = val
                this.loadPost()
            },
            handleCurrentChange(val) {
                this.pageNum = val
                this.loadPost()
            },
            resetParam() {
                this.keyword = ''
            },
            loadPost() {
                this.$axios.post(this.$httpUrl + '/intro/listPage', {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    param: {keyword: this.keyword}
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data
                        this.total = res.total
                    } else {
                        this.$message.error('获取数据失败')
                    }
                })
            }
        },
        beforeMount() {
            this.loadPost()
        }
    }
</script>

<style scoped>

</style>
